module.exports = __webpack_public_path__ + "img/03.a5487955.png";